/**
 * Auth service — OTP, login, register (non-context helpers).
 * These are raw API calls; the AuthContext handles state management.
 */
import apiClient from './apiClient';

/**
 * Send sign-up OTP.
 */
export const sendOtp = async (phone) => {
    return apiClient.post('/auth/send-otp', { phone });
};

/**
 * Verify sign-up OTP.
 */
export const verifyOtp = async (phone, otp) => {
    return apiClient.post('/auth/verify-otp', { phone, otp });
};

/**
 * Send demo OTP.
 */
export const sendDemoOtp = async (phone) => {
    return apiClient.post('/auth/send-otp-demo', { phone });
};

/**
 * Verify demo OTP.
 */
export const verifyDemoOtp = async (phone, otp) => {
    return apiClient.post('/auth/verify-otp-demo', { phone, otp });
};

/**
 * Send forgot-password OTP.
 */
export const sendForgotPasswordOtp = async (phone) => {
    return apiClient.post('/auth/forgot-password/send-otp', { phone });
};

/**
 * Reset password with OTP.
 */
export const resetPassword = async (phone, otp, new_password) => {
    return apiClient.post('/auth/forgot-password/reset', { phone, otp, new_password });
};

/**
 * Book free demo (creates user + tuition post).
 */
export const bookDemo = async (demoData) => {
    return apiClient.post('/book-demo', demoData);
};

/**
 * Validate referral code.
 */
export const validateReferralCode = async (code) => {
    return apiClient.post(`/referral/validate?code=${code}`);
};

// ==================== Referral ====================

export const getMyReferralCode = async () => {
    return apiClient.get('/referral/my-code');
};

export const getReferralStats = async () => {
    return apiClient.get('/referral/stats');
};

export const getMyReferrals = async () => {
    return apiClient.get('/referral/my-referrals');
};
